export { default as CoreBreadcrumb } from './breadcrumb';
export type {
  CoreBreadcrumbItem,
  CoreBreadcrumbProps,
} from '../shared/types/breadcrumb.types';
